const ProductDetailOverviewSkeleton = () => {
    return (
        <div className="container py-4">
            <div className="row">
                {/* Product info skeleton */}
                <div className="col-12">
                    {/* Variants skeleton */}
                    <div className="mb-4">
                        <div className="placeholder-glow mb-2">
                            <span className="placeholder col-4" style={{ height: 20 }}></span>
                        </div>
                        <div className="d-flex flex-wrap gap-2 mb-3">
                            <span className="placeholder placeholder-glow" style={{ height: 38, width: '80px', borderRadius: '0.375rem' }}></span>
                            <span className="placeholder placeholder-glow" style={{ height: 38, width: '80px', borderRadius: '0.375rem' }}></span>
                            <span className="placeholder placeholder-glow" style={{ height: 38, width: '80px', borderRadius: '0.375rem' }}></span>
                        </div>
                        <div className="placeholder-glow mb-2">
                            <span className="placeholder col-4" style={{ height: 20 }}></span>
                        </div>
                        <div className="d-flex flex-wrap gap-2 mb-3">
                            <span className="placeholder placeholder-glow" style={{ height: 38, width: '80px', borderRadius: '0.375rem' }}></span>
                            <span className="placeholder placeholder-glow" style={{ height: 38, width: '80px', borderRadius: '0.375rem' }}></span>
                        </div>
                    </div>
                    
                    {/* Price skeleton */}
                    <div className="placeholder-glow mb-3">
                        <span className="placeholder col-5" style={{ height: 36 }}></span>
                    </div>
                    
                    {/* Add to cart button skeleton */}
                    <div className="placeholder-glow mb-4">
                        <span className="placeholder col-8" style={{ height: 48, borderRadius: '0.375rem' }}></span>
                    </div>
                    
                </div>
            </div>
        </div>
    );
};

export default ProductDetailOverviewSkeleton;








